<template>
  <div v-loading="loading">
      <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small" style="margin-right: 3vw">
          <el-row>
              <el-col :span="24">
                  <el-form-item label="父级：" label-width="120px" style="height: 50%">
                      {{formData.parent_name}}
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="名称：" prop="business_name" label-width="120px" style="height: 50%">
                      <el-input v-model="formData.business_name"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="排序：" prop="sort" label-width="120px" style="height: 50%">
                      <el-input-number v-model="formData.sort" controls-position="right" :min="0" :max="100000000"></el-input-number>
                  </el-form-item>
              </el-col>
          </el-row>
      </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import Xheditor from "@/components/XhComponents/XhEditor";

export default {
  name: "",
  props: ["data", "title"],
  components: {Xheditor},
  data() {
    return {
      formData: this.data,
      rulesAdd: {
        business_name: [{required: true, message: "必填项", trigger: "blur"}],
        sort: [{required: true, message: "必填项", trigger: "blur"}],
      },
      loading: false,
      data:[]
    }
  },
  methods: {
    addOrUpdate() {
      let that = this;
      this.$refs.formData.validate((valid) => {
        if (valid) {
          that.$api.post("/Business/saveData", that.formData,
              function (res) {
                if (res.code === "200" && res.msg === "true") {
                  that.$emit("closeModal");
                  that.$message.success("保存成功");
                } else {
                  that.$message.warning("保存失败");
                }
              },
              function (res) {
                that.$message.error("服务异常，信息出错");
              }
          );
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
  },
  created() {},
  watch: {
    data: function () {
      this.formData = this.data;
    },
  }
}
</script>
<style scoped lang="less">

</style>
